const SIMILARITY_SCORE = {
  HIGH: 'high',
  MODERATE: 'moderate',
  LOW: 'low',
}

export default class FreemiumPlagiarismCheckReport {
  private readonly _id: any;
  private readonly _activeCurrency: string;
  private readonly _availableCurrencies: Array<any>;
  private readonly _displayTimeExceedMessage: Boolean;
  private readonly _displayGrammarCheckMessage: Boolean;
  private readonly _document: Object;
  private readonly _topMatches: Array<any>;
  private readonly _canUserChangeCurrency: Boolean;
  private readonly _similarityScore: number;
  private readonly _links: object;
  private readonly _servicesDetails;

  constructor({
                id,
                activeCurrency,
                availableCurrencies,
                displayTimeExceedMessage,
                displayGrammarCheckMessage,
                document,
                topMatches,
                userCanChangeCurrency,
                similarityScore,
                links,
                servicesDetails
  }) {
    this._id = id;
    this._activeCurrency = activeCurrency;
    this._availableCurrencies = availableCurrencies ? availableCurrencies : [];
    this._displayTimeExceedMessage = displayTimeExceedMessage;
    this._displayGrammarCheckMessage = displayGrammarCheckMessage;
    this._document = document;
    this._topMatches = topMatches;
    this._canUserChangeCurrency = userCanChangeCurrency;
    this._similarityScore = similarityScore;
    this._links = links;
    this._servicesDetails = servicesDetails;
  }

  get id(): any {
    return this._id;
  }

  get activeCurrency(): String {
    return this._activeCurrency;
  }

  get availableCurrencies(): Array<any> {
    let currencies : string[] = [];
    this._availableCurrencies.map(c => currencies.push(c.currency));
    return currencies;
  }

  get displayTimeExceedMessage(): Boolean {
    return this._displayTimeExceedMessage;
  }

  get displayGrammarCheckMessage(): Boolean {
    return this._displayGrammarCheckMessage;
  }

  get document(): Object {
    return this._document;
  }

  get similarityScore(): String {
    if (this._similarityScore >= 5) {
      return SIMILARITY_SCORE.HIGH;
    }

    if (this._similarityScore >= 1) {
      return SIMILARITY_SCORE.MODERATE;
    }

    return SIMILARITY_SCORE.LOW;

  }

  get hasTopMatches(): Boolean {
    return this._topMatches && !!this._topMatches.length;
  }

  get countTopMatched(): number {
    if(this._topMatches && this._topMatches.length) {
      return this._topMatches.length;
    }
    return 0;
  }

  get hasOneTopMatches(): Boolean {
    return this.countTopMatched === 1;
  }

  get topMatches(): Array<any> {
    let matches = this._topMatches;

    matches.forEach(function(obj) {
      obj.matchedWords = obj['matched_word_count_total'];
      obj.sourceType = obj['source_type'];

      delete obj['matched_word_count_total'];
      delete obj['source_type'];
    });

    return matches;
  }

  get canUserChangeCurrency() : Boolean {
    return this._canUserChangeCurrency;
  }

  get links(): object {
    return this._links;
  }

  get serviceSize(): string {
    return this._servicesDetails.filter(s => s.selected === true)[0].name;
  }

  getFullReportPrices(selectedCurrency) {
    let fullReportPrices = this._availableCurrencies.filter(a => a.currency === selectedCurrency)[0].prices;
    let servicesDetails = this._servicesDetails;

    servicesDetails.map(v => {
      fullReportPrices.filter(function (f) {
        if (f.name === v.name) { v['amount'] = f.amount; }
      });
    });

    return servicesDetails;
  }
}
